import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Badge } from "react-bootstrap";

class SearchItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {

  }

  render() {
    const style = {
      inactive: {
        color: "#f5222d",
        backgroundColor: "#fff1f0",
        borderColor: "#ffa39e",
        border: "1px solid",
        borderRadius: "10px",
        fontSize: "14px",
        padding: "2px 8px",
        float: "right"
      },
      active: {
        color: "#429e15",
        backgroundColor: "#f6ffed",
        borderColor: "#429e15",
        border: "1px solid",
        borderRadius: "10px",
        fontSize: "14px",
        padding: "2px 8px",
        float: "right"
      },
      noMap: {
        color: "#808080",
        backgroundColor: "#f2f2f2",
        borderColor: "#cccccc",
        border: "1px solid",
        borderRadius: "10px",
        fontSize: "14px",
        padding: "2px 8px",
        float: "right",
        marginRight: "10px"
      },
      faciltyType: {
        color: "white",
        backgroundColor: "#777777",
        borderRadius: "10px",
        fontSize: "14px",
        padding: "2px 8px",
        float: "right",
        marginRight: "8px"
      }
    };

    function toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    }

    function createTypeTags(codes) {
      var codes;
      if (Array.isArray(codes)) {
        codes = codes.map(code => {
          if (code)
            return <Badge variant="info" className="m-r-sm">{code}</Badge>
        })
      } else {
        if (codes.length > 0)
          codes = <Badge variant="info" className="m-r-sm">{codes}</Badge>
      }
      return codes;
    }

    const SearchItem = (
      <div key={this.props.result.Manifest_ID}>
        <div className="card-item" style={{ fontSize: '1rem' }}>
          <div
            className="card-item-container"
            ref="selectedItem"
          // style={{ backgroundColor: "#aed0ea" }}
          >
            <div className="card-item-title">
              <Link to={"/facility/" + this.props.result.Manifest_ID}>
                {toTitleCase(this.props.result.Manifest_ID)}
              </Link>
            </div>
            <div style={{ fontWeight: "bold" }}>
              {this.props.result.Generator_EPA_ID}
            </div>
            <div >
              {this.props.result.Shipment_Date}
            </div>
            <div>
              {/* {toTitleCase(this.props.result.facStreet1)} */}
            </div>
            <div>
              {/* {toTitleCase(this.props.result.facCity)}, {this.props.result.facSt} {this.props.result.facZip} */}
            </div>
            {/* <div>
                  {toTitleCase(this.props.result.facCounty)} County
                </div> */}
            {/* <div className="m-t-sm">
              {this.props.result.Active === "0" ? (
                <Badge variant="danger" className="m-r-sm">Inactive</Badge>
              ) : (
                  <Badge variant="success" className="m-r-sm">Active</Badge>
                )}
              {createTypeTags(formatFacilityCode(this.props.search.facilityTypeCode))}
            </div> */}
            <div className="btn-detail-div">
              <Link to={"/facility/" + this.props.result.Generator_EPA_ID}>
                <button className="btn-view-details">
                  View Manifest
                  </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );

    return <div>{SearchItem}</div>;
  }
}

const mapStateToProps = state => ({
  search: state.manifest
});

export default connect(mapStateToProps)(SearchItem);
